<template>
  <div>
    <el-tag class="mr-1 mb-1" type="primary" effect="plain" v-for="list in moduleData" :key="list.tag_id">{{list.tag_name}}</el-tag>
  </div>
</template>

<script>

export default {
    name: 'classificationTags',
    data() {
        return {
            title: '标签分类',
        }
    },
    props: {
        moduleData: {
            type: Array,
            default: () => []
        }
    },
    methods: {
         
    }
}
</script>

<style>

</style>